/*
  Signup.js
  ---------
  Purpose: This page provides the registration interface for new admin users. It allows users to create an account by entering their personal details and credentials, and handles validation and submission to the backend.

  Main Logic:
  - Presents a signup form for user details and password input.
  - Validates input fields and manages form state.
  - Integrates with API endpoints for user registration.
  - Handles success and error feedback for the registration process.
  - Utilizes React hooks for state management and side effects.
  - Displays loading indicators and modal dialogs for user feedback.
*/

import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import axios from "axios";
import moment from "moment";

function Signup() {
  const navigate = useNavigate();
  const emailInputRef = useRef();
  const passInputRef = useRef();
  const [loginDetails, setloginDetails] = useState({
    first_name: "",
    last_name: "",
    email: "",
    city: "",
    country: "",
  });
  const [showCreateForm, setShowCreateForm] = useState(false);
  const handleCloseCreateForm = () => setShowCreateForm(false);
  const handleChange = (e) => {
    setloginDetails({ ...loginDetails, [e.target.id]: e.target.value });
  };
  const [error, seterror] = useState({
    status: false,
    message: "",
  });
  const [accessMenus, setAccessMenus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleLoginEmployee = (user) => {
    console.log("Login button clicked for user:", user);
    // Add your login logic here
    window.open(
      `${process.env.REACT_APP_KNOWLEDGE_BASE_URL}/knowledge?uniq_token=${user?.uniq_token}`,
      "_blank"
    );
  };
  async function handleLogin(e) {
    seterror({
      status: false,
      message: "",
    });
    e.preventDefault();
    setIsLoading(true);
    try {
      let response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/adminapi/user/account/setup`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("admin_user_token"),
        },
        data: {
          first_name: loginDetails?.first_name,
          last_name: loginDetails?.last_name,
          email: loginDetails?.email,
          city: loginDetails?.city,
          country: loginDetails?.country,
        },
      });
      if (response?.data?.error) {
        setIsLoading(false);
        seterror({
          status: true,
          message: response?.data?.message,
        });
      }else{
        setloginDetails({
          first_name: "",
          last_name: "",
          email: "",
          city: "",
          country: "",
        });
        setShowCreateForm(false);
        getuserlistFn();
        setIsLoading(false);
      }
      setTimeout(() => {
        seterror({
          status: true,
          message: "",
        });
      }, 5000);
    } catch (error) {
      seterror({
        status: true,
        message: error?.response?.data?.message,
      });
      setIsLoading(false);
    }
  }
  const [loader, setloader] = useState(false);

  const [show, setShow] = useState(false);
  const [x, setX] = useState({
    index: null,
    value: null,
  });
  const [userlist, setuserlist] = useState([]);
  async function getuserlistFn(from) {
    try {
      setloader(true);
      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/usermanage/aiemployee_list`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("admin_user_token"),
        },
      });

      setloader(false);

      if (!response.data.error) {
        setuserlist(response?.data?.employees || []);
      }
    } catch (error) {
      if (error.response.status == 401) {
        localStorage.removeItem("mtm_user_token");
        localStorage.removeItem("mtm_user_data");
        navigate("/");
        return;
      }
      if (error.code === "ECONNABORTED") {
        console.log("Request timed out");
      } else {
        console.log("An error occurred:", error);
      }
    } finally {
      setloader(false);
    }
  }
  const formatDateTime = (dateTimeString, time) => {
    if (!dateTimeString) {
      return "";
    }
    if (time) {
      return moment(dateTimeString).format("D MMMM, YYYY hh:mm A");
    }
    return moment(dateTimeString).format("D MMMM, YYYY");
  };
  useEffect(() => {
    getuserlistFn();
  }, []);
  return (
    <>
      <Container fluid>
        <Row>
          <Col sm={12}>
            <div className="flex items-center">
              {" "}
              <h2 className="fw-700 fs-30 py-4">AI Employee Customer List</h2>
              <div className="ms-auto">
                <button
                  onClick={() => {
                    setShowCreateForm(true);
                  }}
                  className="grd-btn rounded-pill mx-2"
                >
                  Add Ai Employee
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="normal-tbl">
            <table>
              <tr className="tr-bg">
                <th>Customer Id</th>
                <th></th>
                <th>Name</th>
                <th>Email</th>
                <th>Signup Date</th>
                <th>City</th>
                <th>IP Address</th>
                <th>IP Country</th>
                <th>Last Login At</th>
              </tr>
              {loader && (
                <tr>
                  <td colSpan={6} className="text-center">
                    <Loader />
                  </td>
                </tr>
              )}
              {userlist?.map((item, index) => (
                <tr key={item?.email}>
                  <td>{item?.user_id}</td>
                  <td>
                    <button
                      className="grd-btn rounded-pill mx-2"
                      style={{
                        background: `linear-gradient(90deg, rgba(26, 113, 167, 1) 0%, rgba(157, 55, 132, 1) 100%) ${
                          x?.index == index ? x?.value : 0
                        }% / 130%`,
                        padding: "10px 20px",
                        border: "none",
                        color: "white",
                        cursor: "pointer",
                        transition: "background-position 0.3s ease-in-out",
                      }}
                      onClick={() => handleLoginEmployee(item)}
                      onMouseEnter={() =>
                        setX({
                          index: index,
                          value: 100,
                        })
                      }
                      onMouseLeave={() =>
                        setX({
                          index: index,
                          value: 0,
                        })
                      }
                    >
                      Login
                    </button>
                  </td>
                  <td>
                    {item?.first_name} {item?.last_name}
                  </td>
                  <td>{item?.email}</td>
                  {/* <td>
                    {item?.plan}
                    <svg
                      onClick={() => handleShow1(item)}
                      className="icon ms-2 cursor-pointer"
                    >
                      <use href="#icon_info"></use>
                    </svg>
                  </td> */}
                  <td>{formatDateTime(item?.createdAt)}</td>
                  <td>{item?.city}</td>
                  <td>{item?.ip_address}</td>
                  <td>{item?.ip_contry}</td>
                  <td>{formatDateTime(item?.last_login_datetime, true)}</td>
                </tr>
              ))}
            </table>
          </Col>
        </Row>
      </Container>

      <Modal
        size="lg"
        show={showCreateForm}
        onHide={handleCloseCreateForm}
        centered
        animation={true}
      >
        <Modal.Header className="border-0 " closeButton>
          <h5 className="fw-600 fs-20 text-center">Create Account</h5>
        </Modal.Header>

        <Modal.Body className="pt-0">
          <div className="container-fluid bg-white">
            <Row className="position-relative w-100">
              <Col className="signin-right">
                <div className="w-100">
                  <form className="mb-5" onSubmit={handleLogin}>
                    <div className="flex justify-between gap-3 mb-1">
                      <div className="w-[50%]">
                        <label
                          for="first_name"
                          className="form-label fw-400 fs-18"
                        >
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-pill form-control-lg input-shadow border-0"
                          id="first_name"
                          placeholder="Enter First Name"
                          value={loginDetails?.first_name}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="w-[50%]">
                        <label
                          for="last_name"
                          className="form-label fw-400 fs-18"
                        >
                          Last Name
                        </label>
                        <input
                          type="text"
                          className="form-control rounded-pill form-control-lg input-shadow border-0"
                          id="last_name"
                          placeholder="Enter Last Name"
                          value={loginDetails?.last_name}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="mb-1">
                      <label for="email" className="form-label fw-400 fs-18">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control rounded-pill form-control-lg input-shadow border-0"
                        id="email"
                        placeholder="Enter Email"
                        value={loginDetails?.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-1">
                      <label for="city" className="form-label fw-400 fs-18">
                        City
                      </label>
                      <input
                        type="text"
                        className="form-control rounded-pill form-control-lg input-shadow border-0"
                        id="city"
                        placeholder="Enter City"
                        value={loginDetails?.city}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-1">
                      <label for="country" className="form-label fw-400 fs-18">
                        Country
                      </label>
                      <input
                        type="text"
                        className="form-control rounded-pill form-control-lg input-shadow border-0"
                        id="country"
                        placeholder="Enter Country"
                        value={loginDetails?.country}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="text-center text-danger fw-600 fs-20">
                      {error.status && <>{error.message}</>}
                    </div>

                    <button
                      type="submit"
                      className="my-5 grd-btn rounded-pill fs-20 fw-600 w-100 d-flex text-center"
                    >
                      {isLoading ? <Loader /> : <>Submit</>}
                    </button>
                  </form>
                </div>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Signup;
